var newValidateRegExp = require('./newValidateRegExp');
var validate = newValidateRegExp('.@..');
validate.message = 'Expected an email';

module.exports = validate;
